var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3076_238461)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5001 42.86C34.9213 42.86 44.1801 33.6013 44.1801 22.18C44.1801 10.7588 34.9213 1.5 23.5001 1.5C12.0788 1.5 2.82007 10.7588 2.82007 22.18C2.82007 28.6109 5.7555 34.3563 10.3596 38.1492C10.3669 38.1552 10.3604 38.1669 10.3514 38.1639V38.1639C10.3458 38.162 10.3401 38.1661 10.3401 38.1719V42.9452C10.3401 45.4929 13.0254 47.1464 15.3003 45.9996L20.6696 43.293C21.333 42.9586 22.0763 42.825 22.8189 42.849C23.045 42.8563 23.2721 42.86 23.5001 42.86Z",
    fill: "#C37602"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 12.28L25.488 27.736H21.712L21.168 12.28H26ZM23.696 35.224C22.8853 35.224 22.2133 34.9787 21.68 34.488C21.168 33.976 20.912 33.3467 20.912 32.6C20.912 31.8533 21.168 31.2347 21.68 30.744C22.2133 30.232 22.8853 29.976 23.696 29.976C24.4853 29.976 25.136 30.232 25.648 30.744C26.16 31.2347 26.416 31.8533 26.416 32.6C26.416 33.3467 26.16 33.976 25.648 34.488C25.136 34.9787 24.4853 35.224 23.696 35.224Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3076_238461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(0 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4a653d106826a4cbb1aaaa19fe1bc26d.svg";
export { ForwardRef as ReactComponent };